module.exports = __webpack_public_path__ + "static/media/2.889842ee.png";